import React from 'react';
import PropTypes from 'prop-types';
import { Button, makeStyles } from '@material-ui/core';
import closeIcon from '../icons/Close.svg';

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: 35,
    maxHeight: 24,
    maxWidth: 24,
    minWidth: 'unset',
    borderRadius: '50%',
    cursor: 'pointer',
  },
}));

export const CloseButton = ({ onClick, className }) => {
  const classes = useStyles();

  return (
    <Button className={`${classes.root} ${className || ''}`} onClick={onClick}>
      <img src={closeIcon} alt="close" />
    </Button>
  );
};

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};
